import React from 'react';
import { Button, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faRectangleHistoryCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import AddToList from '../properties/add_to_list';
import PropertyBookmark from '../search/components/results/property_bookmark';
import { useSelector } from 'react-redux';
import { selectCallListId, selectCallListItemId } from '../store/selectors/call_console';
import { CALL_CONSOLE, callListUrl, deleteCallListItem } from 'bundles/connect/helpers/prospect_api';
import { displayToast } from 'bundles/connect/helpers/display_toast';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';

type Props = {
  bookmarked: boolean;
  insightsPropertyId: string;
  products: {
    prospecting: boolean;
  };
}

export default function PropertyActions({
  bookmarked,
  insightsPropertyId,
  products
}: Props) {
  const callListId = useSelector(selectCallListId);
  const callListItemId = useSelector(selectCallListItemId);

  const handleRemoveFromList = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (confirm('Are you sure?')) {
      deleteCallListItem(callListItemId).then(() => {
        window.dispatchEvent(new CustomEvent('callListItemRemoved', { detail: { id: callListItemId } }));
        displayToast('Item successfully removed from list', 'success');
      }).catch(() => {
        displayToast('Something went wrong, please try again', 'error');
      });
    }
  };

  return (
    <Row className="gx-2">
      {products.prospecting && (
        <>
          <Col className="d-flex align-items-center" xs="auto">
            {callListId ?
              <OverlayTrigger
                overlay={<Tooltip>Remove from List</Tooltip>}
                placement="left"
              >
                <Button
                  as="a"
                  className="squared text-danger"
                  variant="ghost"
                  onClick={handleRemoveFromList}
                >
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </OverlayTrigger> :
              <PropertyBookmark bookmarked={bookmarked} id={insightsPropertyId} />
            }
          </Col>
          <Col xs="auto">
            {callListId ? (
              <Button
                href={`${callListUrl(CALL_CONSOLE, callListId)}?item_id=${callListItemId}`}
                variant="primary"
              >
                <FontAwesomeIcon icon={faBolt} />
                Start Outreach
              </Button>
            ) :
              (
                <AddToList
                  itemCount={1}
                  itemIds={new Set([insightsPropertyId])}
                  tooltip={false}
                >
                  <Button variant="primary">
                    <FontAwesomeIcon className="me-1" icon={faRectangleHistoryCirclePlus} /> Add To List
                  </Button>
                </AddToList>
              )}
          </Col>
        </>
      )}
    </Row>
  );
}
